var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex float-left vertical-center"},[_c('vs-button',{staticClass:"mr-2",attrs:{"size":"small","icon-pack":"feather","icon":"icon-eye","color":"warning"},on:{"click":_vm.detailRecord}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }